import { observer } from 'mobx-react';
import React, { type FC, useEffect } from 'react';
import { useInjection } from 'inversify-react';

import styled from 'styled-components';

import { Slider } from '@mui/material';
import { TYPES as ImagesTYPES } from '@/engine/app/modules/images/iocTypes.ts';

import type { IImageSliderComponentProps } from '@/engine/app/modules/images/interfaces.ts';
import type { ImagesService } from '@/engine/app/modules/images/Images.service.ts';

export const ImageSliderComponent: FC<IImageSliderComponentProps> = observer(({ isMaximized, sliceType }) => {
  const imagesService = useInjection<ImagesService>(ImagesTYPES.ImagesService);
  const imagesInfo = imagesService.getImageSliceOrientationInfo(sliceType);
  const [currentSlice, setCurrentSlice] = React.useState<number>(0);

  useEffect(() => {
    setCurrentSlice(imagesInfo.currentSlice);
  }, [imagesInfo.currentSlice]);

  const handleChange = (value: number | Array<number>): void => {
    if (!Array.isArray(value)) {
      if (imagesInfo.xRaySlicerParams !== undefined) {
        setCurrentSlice(value);
      } else {
        imagesService.requestSlice(sliceType, value);
      }
    }
  };

  return (
    <SliderWrapper $isMaximized={isMaximized} className="slider-container">
      <Slider
        data-testid="imagesSlider"
        orientation="vertical"
        min={0}
        max={imagesInfo.slicesCount - 1}
        value={currentSlice}
        onChangeCommitted={(): void => {
          if (imagesInfo.xRaySlicerParams !== undefined) {
            imagesService.requestSlice(sliceType, currentSlice);
          }
        }}
        onChange={(_, value): void => {
          handleChange(value);
        }}
        aria-label="slice selector"
      />
    </SliderWrapper>
  );
});

export const SliderWrapper = styled.div<{ $isMaximized?: boolean }>`
  position: absolute;
  right: 0;
  top: ${({ $isMaximized }): string => ($isMaximized ? '50px' : '0')};
  bottom: ${({ $isMaximized }): string => ($isMaximized ? '50px' : '0')};
  padding: ${({ $isMaximized }): string => ($isMaximized ? '1em' : '0.2em')};
`;
